import app from '../app.first';
import Cookies from 'js-cookie';
import slim from '../../vendor/slim/slim.jquery';

app.SlimUploader = class extends app.Component {
    onReady($this) {
        this.slimConfig = $this.data();

        this.slimConfig['willRequest'] = function(xhr) {
            xhr.setRequestHeader('X-CSRF-Token', Cookies.get('csrfToken'))
        };

        if ($this.data('pathToInput')) {
            this.slimConfig.didUpload = (error, data, response) => {
                if (response && response.path) {
                    this.$el.find('[data-upload-field]').val(response.path);
                }
            };
        }

        this.slimConfig['serviceFormat'] = 'file';

        $this.slim(
            this.slimConfig
        );
    }
}